export default __webpack_public_path__ + "static/placeholder-48926a3270fff955c8c228b126ad3dd8.jpg";